<template>
  <section class="columns is-full-width is-align-items-space-between is-multiline">
    <FinancialAdvisorProBillingPlanCard
      class="column m-5"
      :plan="annualPlan"
      :platform-product="platformProduct"
    />
    <FinancialAdvisorProBillingPlanCard
      class="column m-5"
      :plan="monthlyPlan"
      :platform-product="platformProduct"
    />
  </section>
</template>

<script>
import { FinancialAdvisorProBillingPlanForm } from '@/modules/financialadvisor/models/FinancialAdvisorProBillingPlanForm';
import FinancialAdvisorProBillingPlanCard from '@/modules/financialadvisor/components/presentational/FinancialAdvisorProBillingPlanCard.vue';
import { PlatformProduct } from '@/modules/platformproduct/models/PlatformProduct';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FinancialAdvisorProBillingPlans',
  components: { FinancialAdvisorProBillingPlanCard },
  props: {
    platformProduct: {
      type: PlatformProduct
    }
  },
  local() {
    return {
      annualPlan: new FinancialAdvisorProBillingPlanForm().setAsAnnualPlan(),
      monthlyPlan: new FinancialAdvisorProBillingPlanForm().setAsMonthlyPlan()
    };
  }
};
</script>
